import React from 'react';
import PropTypes from 'prop-types';

export default function User(props) {
    const { className } = props;
    return (
        <svg className={className} width="20px" height="20px" viewBox="0 0 20 20">
            <g id="Authentication-signup-V1" transform="translate(-550.000000, -182.000000)">
                <g transform="translate(192.000000, 118.000000)">
                    <g transform="translate(344.000000, 32.000000)">
                        <g transform="translate(14.000000, 32.000000)">
                            <circle id="Oval-3" fill="#009ACF" cx="9.81481481" cy="9.81481481" r="9.81481481" />
                            <g transform="translate(4.074074, 5.555556)">
                                <ellipse id="Oval" fill="#FFFFFF" cx="5.90968275" cy="3.02612277" rx="2.95484138" ry="2.99842787" />
                                <path d="M5.90968275,7.66003497 C3.09686639,7.66003497 0.74304821,9.65414323 0.146223102,12.3251876 C0.130929716,12.393632 2.59259259,14.0740741 5.90968275,14.0740741 C9.22677291,14.0740741 11.6344167,12.1619891 11.622907,12.1178754 C10.9533429,9.55161739 8.64919574,7.66003497 5.90968275,7.66003497 Z" fill="#38CCFF" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

User.propTypes = {
    className: PropTypes.string,
};

User.defaultProps = {
    className: undefined,
};
